import { request } from '@/utils'

//获取产品分页列表接口
export const getSupplierProductPage = async (params: {
  supplierMemberId: string | number
  pageNum: number
  pageSize: number
  productName: string | null
  frontCategories: Array<string> | null
}): Promise<any> => {
  return request.post('/bcp/supplier/market/product/pageLiveProducts', params)
}
//获取产品类目
export const getAllFirCategoryList = async (): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$query_all_primary_front_category',
    {
      data: {},
    },
  )
}
export const submitStewardForm = async (params: any): Promise<any> => {
  return request.post('/api/trantor/service/engine/execute/VEGETA$create_consult_message_service', {
    params:{
      request:{
        consultationProduct:'工品管家',
        ...params,
      }
    },
  })
}
//获取供应商前台类目
export const getFrontDeskCategoryList = async (
  memberId: string | number,
): Promise<any> => {
  return request.get(
    `/bcp/supplier/market/product/getProductFrontCategories/${memberId}`,
  )
}
//根据前台类目转换为后台类目
export const getBackDeskCategoryList = async (params: any): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$get_platform_cate_by_front_ids',
    {
      params: {
        request: params,
      },
    },
  )
}
//获取产品详情接口
export const getSupplierProductDetail = async (
  id: string | number,
): Promise<any> => {
  return request.get(`/bcp/supplier/market/product/getLiveProductById/${id}`)
}

//点赞收藏（取消）接口
export const changeLikeProduct = async (params: {
  /** 供应商memberID */
  marketSupplierId: number | string | undefined
  /** 是否收藏 */
  save: boolean
  /** 是否点赞 */
  like: boolean
}): Promise<any> => {
  return request.post('/bcp/supplier/market/collect/createCollect', {
    ...params,
  })
}
//收藏（喜欢）查询
export const getCollectDetail = async (id: string | number): Promise<any> => {
  return request.get(`/bcp/supplier/market/collect/collectDetail/${id}`)
}
//猜你喜欢
export const getGuessYouLike = async (params?: {
  supplierMemberId: string | number
  productName?: string | null
  pageNum?: number
  pageSize?: number
  frontCategories?: Array<string | number> | null
}): Promise<any> => {
  return request.post('/bcp/supplier/market/product/pageLiveProducts', params)
}

//供应商电话接口
export const getSupplierPhone = async (
  supplierMemberId: number,
): Promise<any> => {
  return request.get(
    `/bcp/supplier/market/contact/getContactInfoBySupplier/${supplierMemberId}`,
  )
}

// //立即询价
// export const inquiryProduct = async (params: {
//   productId: string
//   contactName: string
//   contactPhone: string
// }): Promise<any> => {
//   return request.post('/bcp/supplier/market/product/inquiryProduct', {
//     ...params,
//   })
// }

//获取供应商信息
export const getSupplierInfo = async (id: string | number): Promise<any> => {
  return request.get(`/bcp/supplier/market/portal/detail/${id}`)
}

//立即咨询 立即询价 邀请报价
// "buyer":"买家id",
// "buyerCompanyName": "买家公司名称",
// "buyerPhone": "买家手机号",
// "vendSupplier": "供应商memberId",
// "vendIsPaid": "供应商是否付费",
// "vendNotesSupplier": "供应商名称",
// "msgType": "IMMEDIATELY_CONSULT,立即咨询,ASK_PRICE,立即询价,REQUEST_QUOTATION,邀请报价",
// "messageContent": "留言内容",
// "inquiry": "询价单id",
// "inqTitle": "询价单标题",
// "product": "产品id",
// "productName": "产品名称",
// "prodContactPerson": "产品联系人",
// "prodContactPhone": "产品联系电话"
export const priceInquiryGroup = async (params: any): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$create_buyer_inquiry_info',
    {
      params: { request: params },
    },
  )
}


// 已付费分的供应商 邀请报价
/**
 * 
 * @param params 
 * supplierMemberId 供应商memberId
 * outsideRefId 询价单id
 * @returns 
 */
export const priceInquiryGroupPaid = async (params: {
  supplierMemberId: number | string
  outsideRefId: string | number
  quotationEndTime: number | string
  inqTitle: string | number
}): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$WEBSITE_OPPORTUNITY_TRACK_CREATE_SERVICE',
    {
      params: { request: params },
    },
  )
}

export const priceInquiryGroupPaidNew = async (params: {
  supplierMemberId: number | string
  purchaseId: string | number
}): Promise<any> => {
  return request.post(
    '/bcpcrm/rest/api/supplier/notice/new',
    params,
  )
}

//获取询价单列表
export const getQuoteList = async (params: any): Promise<any> => {
  return request.get(
    '/event/app/sourcing_purchase_list/buy_offer_manage.json',
    { params },
  )
}

// 获取微信分享二维码
export const getWxQrCode = async (params: any): Promise<any> => {
  return request.post(
    '/uc/wx/getWeChatQrCode',
    { ...params },
  )
}


// 获取SEO配置
export const getSeoConfig = async (params:{page: string}): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$query_seo_cf_service',
    {
      params: { request: params },
    },
  )
}
// 工作台供应商自荐过来的记录
export const createBuyerYellowPagesBuryingPoint = async (params: any): Promise<any> => {
  return request.post(
    '/bcpcrm/rest/api/buryingPoint/createBuyerYellowPagesBuryingPoint',
    params,
  )
}